import $ from "jquery";
import React from "react";
import { withRouter } from "react-router-dom";

import * as AplicativoActions from '../../../actions/AplicativoActions';
import * as BoxHelper from '../../../helpers/BoxHelper';
import * as Logger from "../../../helpers/Logger";

class Passo14 extends React.Component {
  constructor(props) {
    super();

    if (props.Menu !== 2) {
      props.setItemState(2);
    }

    this.state = {
      falhas: [],
      meus_uploads: [],
      meus_aplicativos: [],
      aplicativos: [],
      cd_motorista: null,
    };

    this.cd_aplicativo = null;
    this.descricao_aplicativo = null;
  }

  componentWillMount() {
    BoxHelper.boxFormSetup();

    const cadastro_cd_motorista = localStorage.getItem("cadastro_cd_motorista");

    Logger.info(`Passo14 : INICIO : ${cadastro_cd_motorista}`);

    if (typeof cadastro_cd_motorista !== "undefined" && cadastro_cd_motorista !== null) {
      const dados = this.state;

      dados.cd_motorista = cadastro_cd_motorista;

      const zanzar_aplicativos = localStorage.getItem("zanzar_aplicativos");

      if (
        typeof zanzar_aplicativos !== "undefined" &&
        zanzar_aplicativos !== null
      ) {
        dados.aplicativos = JSON.parse(zanzar_aplicativos);
        
        dados.meus_aplicativos = this.loadObjectFromStorage("cadastro_meus_aplicativos");
        dados.meus_uploads = this.loadObjectFromStorage("cadastro_meus_uploads")?.map(Number);
        dados.falhas = this.loadObjectFromStorage("cadastro_meus_uploads_falhas");

        this.setState(dados);
      } else {
        AplicativoActions.listarAplicativos().then((res) => {
          dados.aplicativos = res;

          localStorage.setItem("zanzar_aplicativos", JSON.stringify(res));

          dados.meus_aplicativos = this.loadObjectFromStorage("cadastro_meus_aplicativos");
          dados.meus_uploads = this.loadObjectFromStorage("cadastro_meus_uploads")?.map(Number);

          this.setState(dados);
        });
      }
    } else {
      window.location = "/";
    }
  }

  loadObjectFromStorage = (name) => {
    const data = localStorage.getItem(name);

    return data ? JSON.parse(data) : [];
  }

  _gravar = () => {
    let formOk = true;

    this.state.meus_aplicativos.forEach((cd_aplicativo) => {
      if (!this.state.meus_uploads.includes(parseInt(cd_aplicativo))) {
        formOk = false;

        $(`#aplicativo${cd_aplicativo}`).addClass("has-error");
        $(`#aplicativo${cd_aplicativo}`)
          .parent()
          .find("span")
          .addClass("help-inline");

        $(`#aplicativo${cd_aplicativo}`)
          .parent()
          .find("span")
          .html("Está imagem deve ser enviada.");
      }
    });

    if (formOk) {
      localStorage.removeItem("cadastro_meus_aplicativos");
      localStorage.removeItem("cadastro_meus_uploads");
      localStorage.removeItem("cadastro_meus_uploads_falhas");

      this.props.history.push("/cadastro/sucesso");
    }
  };

  _upload = (cd_aplicativo, descricao_aplicativo) => {
    const url = `/cadastro/passo-14-2?id=${this.state.cd_motorista}&app=${cd_aplicativo}&desc=${descricao_aplicativo}`;

    this.props.history.push(url);
  };

  _atualizar = () => {
    this.props.history.push("/meus-aplicativos/passo-1");
  };

  render() {
    return (
      <div className="page-content header-clear cadastro">
        <div className="title title-36">Perfil de Motorista</div>
        <div className="cf-texto div-body margin-30 space-26">
          Faça uma captura de tela do seu Perfil:
        </div>
        <div className="div-separator">
          <div className="div-progress" style={{ width: "81%" }}>
            <div className="div-progress-bullet bg-purple"></div>
          </div>
          <div className="div-progress-bullet"></div>
        </div>
        <div className="cf-texto div-body margin-30 space-26" style={{ textAlign: "justify" }}>
          O Print a ser feito deve ser da imagem que aparece no aplicativo (Uber, 99) na ABA - ver "PERFIL PÚBLICO".
          <br/>
          Esta imagem apresenta o número total de corridas realizadas e o tempo de aplicativo.
        </div>
        {
          this.state.aplicativos.map((item, k) => {
            if (this.state.meus_aplicativos.includes(item.cd_aplicativo)) {
              return (
                <div key={k}>
                  <button
                    id={"aplicativo" + item.cd_aplicativo}
                    className={
                      "box-input input-label margin-25 space-16 bt-upload-perfil" +
                      (this.state.meus_uploads.includes(item.cd_aplicativo)
                        ? " box-validated"
                        : "") +
                      (this.state.falhas.includes(item.cd_aplicativo)
                        ? " box-falha"
                        : "")
                    }
                    onClick={() =>
                      this._upload(item.cd_aplicativo, item.descricao)
                    }
                  >
                    Enviar captura {item.descricao}{" "}
                    <i
                      className={
                        "icon-26 float-right" +
                        (this.state.meus_uploads.includes(item.cd_aplicativo)
                          ? " fas fa-check" : "")
                      }
                    >
                      {
                        this.state.meus_uploads.includes(item.cd_aplicativo)
                          ? "" : "..."
                      }
                    </i>
                  </button>
                  <br />
                  <span className="div-center"></span>
                </div>
              );
            } else {
              return "";
            }
          })
        }
        <div className="space-40"></div>
        <div className="div-center">
          <button className="bt-login margin-30" onClick={() => this._gravar()}>
            FINALIZAR{" "}
            <i className="fas fa-chevron-right icon-14 float-right"></i>
          </button>
          <div className="space-16"></div>
          <button
            className="bt-login margin-30"
            onClick={() => this._atualizar()}
          >
            ATUALIZAR DADOS
          </button>
        </div>
        <div className="space-71"></div>
      </div>
    );
  }
}

export default withRouter(Passo14);
